module.exports = __webpack_public_path__ + "static/media/ohutu_kaugus.21f2ae31.svg";